export const languages = [
  { code: "auto", label: "Auto detect" },
  { code: "en", label: "English" },
  { code: "fr", label: "French" },
  { code: "es", label: "Spanish" },
  { code: "de", label: "German" },
  { code: "it", label: "Italian" },
  { code: "pt", label: "Portuguese" },
  { code: "pl", label: "Polish" },
  { code: "nl", label: "Dutch" },
  { code: "tr", label: "Turkish" },
  { code: "ru", label: "Russian" },
  { code: "uk", label: "Ukrainian" },
  { code: "ar", label: "Arabic" },
  { code: "hi", label: "Hindi" },
  { code: "ja", label: "Japanese" },
  { code: "ko", label: "Korean" },
  { code: "zh", label: "Chinese" },
] as const;

export type LanguageCode = (typeof languages)[number]["code"];

export const languageName = (code: string): string =>
  languages.find((language) => language.code === code)?.label ?? code;

export const isLanguageCode = (value: unknown): value is LanguageCode =>
  typeof value === "string" && languages.some((language) => language.code === value);
